import { CustomButton, CustomImage, CustomModal, useText, Text } from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import React, { useCallback } from 'react';
import '@src/styles/companyInformation/creditcards/provisionModal.scss';
import warningLogo from '@src/assets/icons/icon-modal-warning.svg';
import { useDispatch, useSelector } from 'react-redux';
import { deleteCard } from '@src/store/slice/mobilExpressSlice';
import PropTypes from 'prop-types';

const CardDeleteModal = ({ modalVisible, handleModalVisible, activeCard, init, type = 1 }) => {
  const dispatch = useDispatch();
  const { selectedCustomer } = useSelector((state) => state?.customer);

  const handleDelete = useCallback(
    async (e) => {
      e.preventDefault();
      const deletePromises = (activeCard?.vouIds || []).map(async (vouId) => {
        return dispatch(
          deleteCard({
            cardToken: activeCard.cardToken?.toString(),
            customerId: selectedCustomer.customerId?.toString(),
            VouId: vouId,
          }),
        );
      });

      await Promise.all(deletePromises);

      handleModalVisible(false);

      await init();
    },
    [activeCard],
  );

  const handleClose = useCallback(
    (e) => {
      e.preventDefault();
      handleModalVisible(false);
    },
    [handleModalVisible],
  );

  return (
    <CustomModal
      className="provision-date-modal"
      maskClosable={false}
      footer={false}
      title={
        <div className="modal-header-title">
          <CustomImage src={warningLogo} />
          <span>
            <Text t="attention" />
          </span>
        </div>
      }
      visible={modalVisible}
      onCancel={handleClose}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className="provision-date-container">
        <h5 className="warning-text-title">
          <Text t="deleteRegisteredCard" />
        </h5>
        <p>
          {activeCard?.maskedCardNumber} <Text t="cardNumberedWillBeDeleted" />
        </p>
        <p>
          <Text t="doYouApprove" />
        </p>

        <div className="footer-btn">
          <CustomButton
            id="companyInformation-creditCards-cardDeleteModal-save-btn"
            className="save-btn"
            onClick={handleDelete}
          >
            <Text t="approve2" />
          </CustomButton>
          <CustomButton
            id="companyInformation-creditCards-cardDeleteModal-cancel-btn"
            className="cancel-btn"
            onClick={handleClose}
          >
            <b>
              <u>
                <Text t="giveUp" />
              </u>
            </b>
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default CardDeleteModal;

CardDeleteModal.propTypes = {
  modalVisible: PropTypes.bool,
  handleModalVisible: PropTypes.func,
  activeCard: PropTypes.shape({
    vouIds: PropTypes.arrayOf(PropTypes.number),
    cardToken: PropTypes.string,
    maskedCardNumber: PropTypes.string,
  }),
  init: PropTypes.func,
  type: PropTypes.number,
};

CardDeleteModal.defaultProps = {
  type: 1,
};
